import React from "react"
import { Dialog, FlatButton, CircularProgress } from "material-ui"
import strings from "../../localization/strings"

interface IProps {
    open: boolean
    addPaymentMethod(): void
    onClose(): void
}

const AddPaymentDialog: React.SFC<IProps> = (props: IProps) => {
    return (
        <Dialog
            open={props.open}
            title={strings.AddPaymentMethod}
            titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
            actions={[
                <FlatButton
                    data-intercom-target={"IP-Btn-CloseAddIPDialog"}
                    label={strings.CANCEL}
                    secondary
                    onTouchTap={props.onClose}
                />,
                <FlatButton
                    data-intercom-target={"IP-Btn-SaveIP"}
                    label={strings.AddPaymentMethod}
                    primary
                    onTouchTap={props.addPaymentMethod}
                />
            ]}
        >
            <hr />
            <div style={{ paddingRight: 20, paddingLeft: 20 }}>
                <div style={{ width: "100%" }}>
                    <div id="card-element">
                        <CircularProgress /> {strings.loading}...
                    </div>
                </div>
            </div>
        </Dialog>
    )
}

export default AddPaymentDialog